import type { ReactNode } from 'react';
import { Link } from 'react-router';

/**
 * 페이지 머리 (2026-09-13 통일): 제목 17px + 옆 배지 + 아래 12px 회색 설명, 오른쪽 보조 액션(링크·필터), 위 "← 목록" 링크.
 * 페이지 단위 CTA 는 여기가 아니라 하단 PageActions(CR-022)에 둔다. 스타일은 index.css 의 .page-* 만 쓴다.
 *   <PageHeader title="사용자" description="…" actions={<LinkButton …/>} back={{ to: '/users', label: '사용자' }}><Badge>…</Badge></PageHeader>
 */
export function PageHeader({ title, description, actions, back, children }: { title: ReactNode; description?: ReactNode; actions?: ReactNode; back?: { to: string; label: string }; /** 제목 옆 배지·부가 텍스트 */ children?: ReactNode }) {
  return (
    <div className="page-head">
      {back && <Link to={back.to} className="page-back">← {back.label}</Link>}
      <div className="page-head-row">
        <div className="page-head-main">
          <div className="page-head-title"><h1 className="page-title">{title}</h1>{children}</div>
          {description && <p className="page-desc">{description}</p>}
        </div>
        {actions && <div className="page-head-actions">{actions}</div>}
      </div>
    </div>
  );
}
